var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileName)?_c('div',[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"width":"100%","src":("" + _vm.getFilePath)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202f0d1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/creationOpportunite/panier/previsualiserOpportunite/PDFJSViewer.vue
// module id = null
// module chunks = 